import GearFilled from '../../src/legacy/GearFilled.tsx';
export default GearFilled;
